g<template>
  <div id="logo">
    <router-link to="/">
      <h1>Donut World</h1>
      <h4>The Little Red Barn in Gresham</h4>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Logo"
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #990000;
}

h1,
h4 {
  margin: 0;
}

h1 {
  font-weight: 800;
  font-family: "Kanit", sans-serif;
  color: #990000;
  letter-spacing: calc((16 / 1000) * 1em);
  font-size: clamp(2.5rem, 3.9vw, 3.125rem);
  line-height: 0.75;
  letter-spacing: 0.15rem;
  text-transform: uppercase;
}

h4 {
  color: var(--color-dark-2);
}
</style>
